var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"learning-chart"},[(_vm.width)?_c('apexchart',{attrs:{"type":_vm.type,"height":_vm.height,"width":_vm.width,"options":_vm.options,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }